module.exports = __webpack_public_path__ + "img/no-content.1af0ad99.png";